import React from 'react';
import '../../App.css';


export default function Busca() {
    return <>
        <body className='busca'>
            <div className='center'>
                <h1> Infelizmente n&atilde;o h&aacute; bolsas dispon&iacute;veis nessa regi&atilde;o no momento :( </h1>
            </div>
        </body>
    </>;

}